import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["input", "hidden", "removeButton"]
  static values = { sourceUrl: String }

  connect() {
    if (this.element.dataset.template === "true") return

    const initialValue = this.hasHiddenTarget ? this.hiddenTarget.value : ""
    const initialLabel = this.inputTarget.value

    // Clear the input's text value before TomSelect wraps it; otherwise
    // TomSelect treats the text as an option/item, which collides with the
    // real {id, label} option we add below.
    this.inputTarget.value = ""

    this.tomSelect = new TomSelect(this.inputTarget, {
      valueField: "value",
      labelField: "label",
      searchField: "label",
      maxItems: 1,
      maxOptions: 50,
      create: false,
      load: (query, callback) => {
        const url = new URL(this.sourceUrlValue, window.location.origin)
        url.searchParams.set("query", query)
        fetch(url, { headers: { "Accept": "application/json" } })
          .then(r => r.json())
          .then(callback)
          .catch(() => callback())
      },
      onChange: (value) => {
        if (this.hasHiddenTarget) this.hiddenTarget.value = value || ""
        if (this.hasRemoveButtonTarget) {
          this.removeButtonTarget.style.display = value ? "" : "none"
        }
      }
    })

    if (initialValue) {
      this.tomSelect.addOption({ value: initialValue, label: initialLabel })
      this.tomSelect.addItem(initialValue, true)
    }
  }

  disconnect() {
    if (this.tomSelect) this.tomSelect.destroy()
  }

  remove(event) {
    event.preventDefault()
    if (this.tomSelect) this.tomSelect.clear()
    if (this.hasHiddenTarget) this.hiddenTarget.value = ""
    if (this.hasRemoveButtonTarget) this.removeButtonTarget.style.display = "none"
  }
}
